import React from "react";

import { PieChart } from "@mui/x-charts/PieChart";

import { useIndicators } from "../../hooks/useIndicators";
import { useWidgetFetch } from "../../hooks/useWidgetFetch";
import { RendererProps } from "./types";

import "./styles.scss";

export const PieWidget = (props: RendererProps) => {
  const { data, isLoading, error } = useWidgetFetch(props.config.title, props.config.dataSource, props.optionValues);

  const someIndicatorView = useIndicators(props, isLoading, error);
  if (someIndicatorView) {
    return someIndicatorView;
  }

  return (
    <div className="pie-widget">
      <PieChart
        margin={{ right: 0, bottom: 0, left: 0, top: 0 }}
        width={300}
        height={300}
        // slotProps={{
        //   legend: {
        //     direction: "row",
        //     position: { vertical: "bottom", horizontal: "middle" },
        //   },
        // }}

        slotProps={{
          legend: {
            hidden: true,
          },
        }}
        colors={props.colors}
        series={[
          {
            innerRadius: 50,
            outerRadius: 100,
            data:
              data &&
              data.map(([label, value]: any, index: number) => ({
                id: index,
                value: value,
                label: label,
                arcLabel: "value",
              })),
          },
        ]}
      />
      <div className="legend">
        {data.map(([Label, value], index) => (
          <div key={index} className="item">
            <div style={{ backgroundColor: props.colors[index % props.colors.length] }} className="dot" />
            {Label}
          </div>
        ))}
      </div>
    </div>
  );
};
